import {
    GET_CURRENT_NEW
} from './constants';

const initialState = {
    currentNew: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_NEW: {
            return {
                ...state,
                currentNew: action.payload,
            };
        }
        default:
            return state;
    }
};

